// extracted by mini-css-extract-plugin
export default {"NavStack":"Navbar_NavStack__kdlbb","heading":"Navbar_heading__hLr1o","name":"Navbar_name__q3hL-","buttontop":"Navbar_buttontop__BTi7k","hub":"Navbar_hub__ixo9n"};